import { connect } from 'react-redux';

import { setUXProp } from '@store/actions/ux';
import GridView from './gridview';

const mapStateToProps = state => ({
  minutesPixelRatio: state.ux.minutesPixelRatio,
  beginDate: state.ux.beginDate,
  isDST: state.ux.isDST,
  isLoadingTvguide: state.ux.isLoadingTvguide,
});

const mapDispatchToProps = dispatch => ({
  hasRendered: () => {
    dispatch(
      setUXProp({
        pixelRatioChanged: false,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GridView);
